import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-confirmation-dialog',

  standalone: false,
  template: `
    <h1 mat-dialog-title>{{ data.title ?? data.message }}</h1>
    <mat-dialog-content *ngIf="data.title">{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button
        mat-flat-button
        [color]="data.color ?? 'primary'"
        [mat-dialog-close]="true"
      >{{ data.confirmLabel ?? 'Confirm' }}</button>
    </mat-dialog-actions>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string, confirmLabel: string, color: ThemePalette, title?: string }) {}
}
